module.exports = __webpack_public_path__ + "static/media/shopping-basket.34713891.svg";